import { AxiosInstance } from 'axios';
import { ICandidateProfile, ICandidature, IEditableCandidature } from '../models';

export class CandidatureClient {

    constructor(private axiosClient: AxiosInstance) { }

    public get apiUrl() {
        return `/candidature`;
    }

    public async getProfile(electionId: string, candidatureId: string): Promise<ICandidateProfile> {

        const response = await this.axiosClient.get(
            `${this.apiUrl}/${electionId}/${candidatureId}/profile`
        );

        return response.data;
    }

    public async get(candidatureIdentifier: string): Promise<ICandidature> {

        const response = await this.axiosClient.get(
            `${this.apiUrl}/${candidatureIdentifier}`
        );

        return response.data;
    }

    public async update(candidatureIdentifier: string, editable: IEditableCandidature): Promise<ICandidature> {

        const response = await this.axiosClient.put(
            `${this.apiUrl}/${candidatureIdentifier}`,
            editable
        );

        return response.data;
    }
}
